/*=============================================== PageLoading ===============================================*/
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*==================== Imports ====================*/
import React, { useEffect } from "react";
import styled from "styled-components";
import Mixins from "./Mixins";
import Loader from "./Loader";
/*==================== Component ====================*/
var PageLoading = function (_a) {
    var _b = _a.color, color = _b === void 0 ? "primary" : _b, props = __rest(_a, ["color"]);
    useEffect(function () { return document.body.classList.add("stop-scrolling"); });
    return (React.createElement(Container, __assign({ "$color": color }, props),
        React.createElement(Loader, { size: "xxl", color: color === "white" ? "primary" : "white" })));
};
export default PageLoading;
/*==================== Styles ====================*/
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: fixed;\n    width: 100vw;\n    height: 100vh;\n    top: 0;\n    left: 0;\n    background-color: ", ";\n    ", ";\n    z-index: 999;\n"], ["\n    position: fixed;\n    width: 100vw;\n    height: 100vh;\n    top: 0;\n    left: 0;\n    background-color: ", ";\n    ", ";\n    z-index: 999;\n"])), Mixins.ColorsShort, Mixins.Flexbox({
    $align: "center",
    $justify: "center",
}));
var templateObject_1;
